module.exports = __webpack_public_path__ + "static/angela-bains-e5638b24ae32604ee1071c441d1e5ddc.jpg";